import cn from 'classnames'
import { promotionDate } from '@lib/promotion/utils'
import { ChapterPromotionProps } from './interface'

export function ChapterPromotion({ data, isDrawer }: ChapterPromotionProps) {
  return (
    <>
      {data && (
        <div
          className={cn('mobile:px-[20px]', {
            'desktop-tablet:px-[20px]': isDrawer,
          })}
        >
          <div
            className={cn(
              'mobile:flex-col my-[30px] font-medium font-mitr bg-red-1 dark:bg-dark-9 rounded-lg',
              {
                'desktop-tablet:flex': !isDrawer,
                'desktop-tablet:flex-col': isDrawer,
              }
            )}
          >
            <div
              className={cn(
                'flex items-center justify-center py-[20px] px-[50px] mobile:px-[35px] rounded-lg bg-red text-white w-auto',
                {
                  'desktop-tablet:min-w-[250px]': !isDrawer,
                }
              )}
            >
              <div className='desktop:flex desktop:space-x-[5px]'>
                <div className='text-[24px] mobile:text-[20px]'>
                  ลด {data.totalChapter} ตอน
                </div>
              </div>
            </div>
            <div
              className={cn(
                'mobile:flex-col desktop:space-x-[30px] items-center mobile:justify-center py-[20px] px-[50px] mobile:px-[64px]',
                {
                  'desktop:flex': !isDrawer,
                }
              )}
            >
              <div
                className={cn(
                  'font-light text-[24px] mobile:text-[18px] mobile:text-center dark:text-dark-10',
                  {
                    'text-center': isDrawer,
                  }
                )}
              >
                {promotionDate(
                  data.startedAt,
                  data.endedAt,
                  'ตั้งแต่วันที่',
                  true
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
